import { useQuery } from "@tanstack/react-query"
import { generateGmailAuthLinkQuery } from "modules/settings/lib/gmail/generateGmailAuthLinkQuery"

export function useGenerateGmailAuthLinkQuery(
  ...args: Parameters<typeof generateGmailAuthLinkQuery>
) {
  return useQuery(generateGmailAuthLinkQuery(...args))
}
